import { render, staticRenderFns } from "./ModelControls.vue?vue&type=template&id=13a5eaad&scoped=true"
import script from "./ModelControls.vue?vue&type=script&lang=js"
export * from "./ModelControls.vue?vue&type=script&lang=js"
import style0 from "./ModelControls.vue?vue&type=style&index=0&id=13a5eaad&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a5eaad",
  null
  
)

export default component.exports